import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { IErrorAlert } from "src/app/interfaces/error.interface";
import { Receipt } from "../../../models/receipt.model";
import { ModalService } from "../../../services/modal.service";
import { RequestService } from "../../../services/request.service";

@Component({
  selector: "app-receipt-detail",
  templateUrl: "./receipt-detail.component.html",
  styleUrls: [
    "./receipt-detail.component.css",
    "../receipt-modal/receipt-modal.component.css",
  ],
})
export class ReceiptDetailComponent implements OnInit, OnDestroy {
  @Input() events: Observable<void>;
  @Input() initEvents: Observable<number>;
  private hidingEventsSubscription: Subscription;
  private initEventsSubscription: Subscription;

  receipt: Receipt;
  url: string;
  error: IErrorAlert;
  loading = true;

  constructor(public _modal: ModalService, public _request: RequestService) {
    this.initEvents = _modal.initEvents.asObservable();
    this.receipt = this._modal.receipt;
  }

  ngOnInit(): void {
    this.init(this.receipt.number);
    this.hidingEventsSubscription = this.events.subscribe(() => this.hide());
    this.initEventsSubscription = this.initEvents.subscribe((number: number) =>
      this.init(number)
    );
  }

  ngOnDestroy() {
    this.hidingEventsSubscription.unsubscribe();
    this.initEventsSubscription.unsubscribe();
  }

  hide() {
    this._modal.hide();
    this.reset();
  }

  reset() {
    this.url = null;
    this.error = null;
  }

  init(number: number) {
    this.loading = true;
    this.receipt = this._modal.receipt;
    this._request.downloadReceiptPdf(number).subscribe(
      (data) => {
        this.url = data;
        this.loading = false;
      },
      (err: IErrorAlert) => {
        this.error = err;
        this.loading = false;
      }
    );
  }
}
